module.exports = __webpack_public_path__ + "img/company-avatar__default.66546057.png";